import { forceMobileViewAtom } from 'app/atoms/ui';
import { useBreakpoint } from 'app/utils/web-helpers';
import { useAtom } from 'jotai';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

export function DeviceGate({ children }: { children: ReactNode }) {
  const tabletBreakpoint = useBreakpoint(768);
  const [, setForceMobileView] = useAtom(forceMobileViewAtom);

  useEffect(() => {
    setForceMobileView(!tabletBreakpoint);
  }, [setForceMobileView, tabletBreakpoint]);

  return children;
}
